import { twClassMerge } from '@healthhub/react-ui';
import type { PropsWithChildren } from 'react';
import { useContext } from 'react';

import { LanguageSelection } from '@shared/components';
import { GlobalBreadcrumbsContext } from '@shared/context/GlobalBreadcrumbsContextWrapper';

import MaxWidthContainer from '../MaxWidthContainer';
import PortalBreadcrumbs from '../PortalBreadcrumbs';

interface PageContentProps {
  className?: string;
  noStyleContent?: boolean;
}

const PageContent = ({ children, className, noStyleContent }: PropsWithChildren<PageContentProps>) => {
  const { globalBreadcrumbs } = useContext(GlobalBreadcrumbsContext)!;
  const hasBreadcrumbs = (globalBreadcrumbs?.portal?.data?.length ?? 0) > 0;

  return (
    <main className="flex flex-1 flex-col items-center" id="main-content" role="main" tabIndex={-1}>
      <div
        className={twClassMerge(
          'flex w-full justify-center px-3 py-4 md:px-8 lg:px-18',
          globalBreadcrumbs?.portal?.className
        )}
      >
        <MaxWidthContainer className="flex flex-col justify-between gap-6 md:flex-row md:gap-4">
          {!!hasBreadcrumbs && (
            <PortalBreadcrumbs
              breadcrumbs={globalBreadcrumbs?.portal?.data}
              isIncludedEservices={globalBreadcrumbs?.portal?.isIncludedEservices}
            />
          )}
          <LanguageSelection className="lg:ml-auto" />
        </MaxWidthContainer>
      </div>
      <div
        className={twClassMerge('flex w-full justify-center min-h-[60vh]', {
          'px-3 pt-2 lg:pt-6 pb-6 md:px-8 md:pb-10 lg:px-18': !noStyleContent,
        })}
      >
        <MaxWidthContainer className={twClassMerge({ 'max-w-none': noStyleContent }, className)}>
          {children}
        </MaxWidthContainer>
      </div>
    </main>
  );
};

export default PageContent;
